import { ChangeDetectionStrategy, Component } from '@angular/core';
import { TranslationModule } from '@fino-ui/translation';
import { InfoComponent } from '../info/info.component';

@Component({
  selector: 'app-please-be-patient',
  templateUrl: './please-be-patient.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [InfoComponent, TranslationModule],
})
export class PleaseBePatientComponent {}
